export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

export function getAuthToken() {
    const token = sessionStorage.getItem('token');
    return token;
}

export function getUserLevel() {
    const userLevel = sessionStorage.getItem('userLevel');
    return userLevel;
}